import React from 'react';

import Navbar from './Navbar';
import { FaCheckCircle } from 'react-icons/fa'; // Importing an icon for the green checkmark

const Popup = () => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50vh',
    backgroundColor: '#f4f6f8',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
  };

  const checkmarkStyle = {
    color: '#28a745', // Green color for the checkmark
    fontSize: '4rem',
    marginBottom: '20px',
  };

  const titleStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
  };

  const messageStyle = {
    fontSize: '1rem',
    color: '#666',
  };

  return (
    <div>
      <Navbar />
      <div style={containerStyle}>
        <FaCheckCircle style={checkmarkStyle} />
        <h1 style={titleStyle}>Thank You!</h1>
        <p style={messageStyle}>Your Data Successfully Submitted.</p>
      </div>
    </div>
  );
};

export default Popup;